export default {"src":"/_next/static/media/laptop.4f97e15f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};